'use strict';

import MlbTeamData from './lib/MlbTeamData';

export default MlbTeamData;

